export default "__VITE_ASSET__CotNMpT0__"